import { useEffect } from "react";

export function useRaceNotifications(settings) {
  useEffect(() => {
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
    const check = () => {
      const race = settings?.race;
      if (!race) return;
      const now = Date.now();
      const ms = (d) => (d ? new Date(d).getTime() : null);
      const fire = (key, title, body) => {
        if (localStorage.getItem(`notif-${key}`)) return;
        localStorage.setItem(`notif-${key}`, "1");
        try {
          new Notification(title, { body });
        } catch {
          // notifica di sistema non disponibile
        }
      };
      const lock = ms(race.lock_at);
      if (lock && now > lock - 2 * 3600e3 && now < lock)
        fire("lock2h", "FantasyRace — Chiusura Formazioni", "Mancano 2 ore alla chiusura delle formazioni! Hai scelto il tuo Capitano?");
      const cws = ms(race.captain_window_start);
      if (cws && now > cws)
        fire("prove-end", "FantasyRace — Prove Terminate", "Le Prove del Sabato sono terminate! Entra nell'app per valutare se cambiare il Capitano per la Gara di domani!");
      if (race.gara_finita)
        fire("official", "FantasyRace — Classifiche Ufficiali", "Classifiche Ufficiali della 69° Salita Monti Iblei pubblicate! Controlla la tua posizione!");
    };
    check();
    const t = setInterval(check, 60000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);
}
